import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { reqStFilterAction } from '../../modules/st/stFilterModule';
import SpaceFilterList from '../../components/st/SpaceFilterList';
import { filter, forEach, concat } from 'lodash';
import SpacePriceFilter from '../../components/st/SpacePriceFilter';
import { setStDelFilterAction, setStFilterChangeAction } from '../../modules/st/stContentsModule';
import { useHistory } from "react-router-dom";

const SpaceFilterContainerBlock = styled.div`
    margin-bottom: 40px;
`;

const SpaceFilterContainer = ({ reset }) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [requestfilter, setRequestfilter] = useState(false);

    const { stFilterInfo, error, loading } = useSelector(
        ({ stFilterReducer, loadingReducer }) => ({
            stFilterInfo: stFilterReducer.stFilterInfo,
            error: stFilterReducer.error,
            loading: loadingReducer['sp/ST_FILTER'],
        })
    );

    useEffect(() => {
        if (stFilterInfo === null || stFilterInfo.length === 0) {
            setRequestfilter(true);
            dispatch(reqStFilterAction());
        }
    }, [])

    useEffect(() => {
        if (stFilterInfo !== null && stFilterInfo.length > 0 && (history.action === 'PUSH' || requestfilter)) {
            let stDelFilter = [];
            forEach(stFilterInfo, (item, idx) => {
                let arrFilter = filter(item, function (curitem, idx) {
                    return idx !== 0;
                });

                arrFilter.map((item) => {
                    let filtervalue = item.filter1_id * 100 + item.filter2_id * 1;
                    stDelFilter = concat(stDelFilter, filtervalue);
                })
            })
            dispatch(setStFilterChangeAction(true));
            setRequestfilter(false);
            dispatch(setStDelFilterAction(stDelFilter))
        }
    }, [stFilterInfo, history])

    if (error || loading || stFilterInfo === null) {
        return <SpaceFilterContainerBlock></SpaceFilterContainerBlock>
    }

    // console.log("stFilterInfo : " + JSON.stringify(stFilterInfo));

    if (stFilterInfo === null || stFilterInfo === undefined) {
        return <SpaceFilterContainerBlock />
    }

    return (
        <SpaceFilterContainerBlock>
            {
                stFilterInfo.map((item) => {
                    let title = item[0].filter_name;
                    let filtervalue = item[0].filter1_id * 100 + item[0].filter2_id * 1;
                    let arrFilter = filter(item, function (curitem, idx) {
                        return idx !== 0;
                    });

                    return (<SpaceFilterList
                        key={filtervalue}
                        filterTitle={title}
                        filterList={arrFilter}
                        reset={reset}
                    />);
                })
            }
            <SpacePriceFilter />
        </SpaceFilterContainerBlock>
    );
};

export default SpaceFilterContainer;